<template>
  <div>Icon</div>
</template>

<script>
export default {}
</script>

<style scoped></style>
